<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Select new products</span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="newProductsState" @submit.prevent="saveNewProducts">
          <v-container fluid grid-list-xl class="pt-0">
            <v-layout wrap align-top justify-end>
              <v-btn color="warning" flat @click="close">
                Close
              </v-btn>
              <v-btn type="submit" color="success">
                Save
              </v-btn>
            </v-layout>
          </v-container>
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>
              <v-flex xs12>
                <async-autocomplete
                  v-model="productsSelected"
                  :items="ingredients"
                  name="products"
                  label="Select products"
                  item-text="name"
                  item-value="name"
                  return-object
                  multiple
                />
              </v-flex>
              <v-flex xs12>
                <async-autocomplete
                  v-model="trialObjectsSelected"
                  :items="trialData"
                  name="trial"
                  label="Select trial ingredients"
                  item-text="name"
                  item-value="name"
                  return-object
                  multiple
                />
              </v-flex>
              <v-flex sx12>
                <multiple-inputs
                  v-model="customIngredientsSelected"
                  :items="customIngredients"
                  name="customIngredients"
                  label="Add custom ingredients"
                  item-text="name"
                  item-value="name"
                  :returnObject="true"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// import AnalysisComponents from '@/orm/models/AnalysisComponents';
import AnalysisProducts from '@/orm/models/AnalysisProducts';
import CustomIngredients from '@/orm/models/CustomIngredients';
import asyncAutocomplete from '@/components/form/asyncAutocomplete';
import multipleInputs from '@/components/form/multipleInputs';

import RecipeModule from '@/orm/models/RecipeModule';
import MixingModule from "@/orm/models/MixingModule";
// import Recipes from "@/orm/models/Recipes";


export default {
  name: 'newProductsPopup',
  props: {
    dialog: {
      type: Boolean,
      default: () => false,
    },
    products: {
      type: Array,
      default: () => [],
    },
    ingredientsGroups: Array,
  },
  data() {
    return {
      trial_id: this.$route.params.id,
      productsSelected: [],
      newProductsState: {},
      customIngredientsSelected: [],
      trialObjectsSelected: [],
      rawProcessData: [],
      rawRecipesData: [],
      rawRecipesInrgedientsData: [],
      rawMixesData: [],
      rawPremixesData: []

    };
  },
  mounted() {
    this.getProcessData();
    this.getRecipeData();
    this.getMixesPremixes();

  },
  watch: {
    dialog(value) {
      if (value) {
        this.productsSelected = this.products.filter(ingr => ingr.type === 'INGREDIENT');
        this.trialObjectsSelected = this.products.filter(ingr => ingr.type === 'TRIALINGR');
        this.customIngredientsSelected = this.products.filter(ingr => ingr.type === 'CUSTOMINGR');
      }
    }
  },
  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
    allProducts() {
      return [...this.productsSelected, ...this.trialObjectsSelected, ...this.preparedCustomIngredients]

    },
    categories() {
      return this.ingredientsGroups
        .reduce((acc, group) => {
          const categories = group.categories.map(category => {
            category.groupId = group.id;
            return category;
          });
          acc = [
            ...acc,
            ...JSON.parse(JSON.stringify(categories)),
          ];
          return acc;
        }, []);
    },
    ingredients() {
      return this.categories
        .reduce((acc, cat) => {
          const ingredients = cat.ingredients.map(ingredient => {
            ingredient.groupId = cat.groupId;
            ingredient.categoryId = cat.id;
            ingredient.target = 0;
            ingredient.result = 0;
            return ingredient;
          });
          acc = [
            ...acc,
            ...JSON.parse(JSON.stringify(ingredients)),
          ];
          return acc;
        }, []);
    },
    customIngredients() {
      return CustomIngredients.all();
    },
    preparedCustomIngredients() {
      return this.customIngredientsSelected.map(ci => {
        if (typeof ci === 'object') return ci;
        return new CustomIngredients({ name: ci, type: "CUSTOMINGR" }).$toJson();
      });
    },
    trialData() {
      const processIng = Array.isArray(this.prepareProcessIngredients) ? this.prepareProcessIngredients : [];
      const recipesIng = Array.isArray(this.prepareRecipesIngredients) ? this.prepareRecipesIngredients : [];
      const recipes = Array.isArray(this.prepareRecipes) ? this.prepareRecipes : [];
      const mixes = Array.isArray(this.prepareMixes) ? this.prepareMixes : [];
      const preMixes = Array.isArray(this.preparePremixes) ? this.preparePremixes : [];
      const mixesIng = Array.isArray(this.prepareMixesIngredients) ? this.prepareMixesIngredients : [];

      return [...processIng, ...recipes, ...recipesIng, ...mixes, ...preMixes, ...mixesIng]
    },
    prepareProcessIngredients() {
      if (!this.rawProcessData.length) {
        return;
      }

      return JSON.parse(JSON.stringify(this.rawProcessData)).reduce((s1, a) => {
        if (Array.isArray(a.stages)) {
          return [...s1, ...a.stages.reduce((s2, b) => {
            if (Array.isArray(b.steps)) {
              return [...s2, ...b.steps.reduce((s3, c) => {
                const rawInlet = Array.isArray(c.inlet) ? c.inlet : [];
                const rawOutlet = Array.isArray(c.outlet) ? c.outlet : [];

                const inlet = rawInlet.map(item => {
                  item.name = a.name + ' ' + b.name + ' ' + c.name + ' ' + item.name;
                  item.id = item.id + a.name.split(' ').join('') + b.name.split(' ').join('') + c.name.split(' ').join('') + item.name.split(' ').join('');
                  item.type = "TRIALINGR";
                  return item
                });
                const outlet = rawOutlet.map(item => {
                  item.name = a.name + ' ' + b.name + ' ' + c.name + ' ' + item.name;
                  item.id = item.id + a.name.split(' ').join('') + b.name.split(' ').join('') + c.name.split(' ').join('') + item.name.split(' ').join('');
                  item.type = "TRIALINGR";
                  return item
                });

                  return [...s3, ...inlet, ...outlet]
              }, [])]
            } else {
              return s2;
            }
          }, [])]
        } else {
          return s1;
        }
      }, []);
    },
    prepareRecipesIngredients() {
      if (!this.rawRecipesInrgedientsData.length) {
        return;
      }
      return this.rawRecipesInrgedientsData.map((item) => {
        return {...item, name: 'WM INGR ' + item.name, id: item.id + 'WMINGR', type: "TRIALINGR"};
      });
    },
    prepareRecipes() {
      if (!this.rawRecipesData.length) {
        return;
      }
      return JSON.parse(JSON.stringify(this.rawRecipesData)).map((item) => {
        return {...item, name: 'WM ' + item.name + ' ' + item.process.name, id: item.id + 'WM', type: "TRIALINGR"};
      });
    },
    prepareMixes() {
      if (!this.rawMixesData.length) {
        return;
      }
  
      return this.rawMixesData.map((item) => {
        return {...item, name: 'MIX ' + item.name, id: item.id + 'MIX', type: "TRIALINGR"};
      });
    },
    preparePremixes() {
      if (!this.rawPremixesData.length) {
        return;
      }
      return this.rawPremixesData.map((item) => {
        return {...item, name: 'PREMIX ' + item.name, id: item.id + 'PREMIX', type: "TRIALINGR"};
      });
    },
    prepareMixesIngredients() {
      if (!this.rawMixesData.length) {
        return;
      }

      return JSON.parse(JSON.stringify(this.rawMixesData)).reduce((s1, i) => {
        if (Array.isArray(i.ingredients)) {
          const ings = i.ingredients.map((item)=>{
            item.name = 'MIX ' + i.name + ' INGR ' + item.name;
            item.id = item.id + 'MIX' + i.name + 'INGR'
            item.type = "TRIALINGR";
            return item
          });
          return [...s1, ...ings]
        } else {
          return s1;
        }
      }, []);

    }
  },
  methods: {
    close() {
      this.newProductsState._reset();
      this.dialogLocal = false;
      this.selectedCustomIngredients = [];
    },
    async saveNewProducts() {
      if (!this.newProductsState.$valid) {
        return;
      }
      try {

        await AnalysisProducts.create({ data: this.allProducts });
      } finally {
        this.$emit('savenewproducts');
        this.close();
      }
    },
    async getProcessData() {
      const { params } = this.$route;
      const { processes } = await RecipeModule.$get({ params });

      this.rawProcessData = processes;
    },
    async getRecipeData() {
      const { params } = this.$route;
      const { recipes } = await RecipeModule.$get({ params });

      this.rawRecipesData = recipes.items ? recipes.items : [];
      this.rawRecipesInrgedientsData = recipes.ingredients ? recipes.ingredients : [];
    },
    async getMixesPremixes() {
      const { params } = this.$route;
      const { mixes, premixes } = await MixingModule.$get({ params });

      this.rawMixesData = mixes.items ? mixes.items : [];
      this.rawPremixesData = premixes.items ? premixes.items : [];
    }
  },
  components: {
    asyncAutocomplete,
    multipleInputs
  },
};
</script>
